module.exports = __webpack_public_path__ + "img/colorful-char2.6cc980a9.png";